import { render, staticRenderFns } from "./SupplierReport.vue?vue&type=template&id=181d6080&scoped=true"
import script from "./SupplierReport.vue?vue&type=script&lang=js"
export * from "./SupplierReport.vue?vue&type=script&lang=js"
import style0 from "./SupplierReport.vue?vue&type=style&index=0&id=181d6080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d6080",
  null
  
)

export default component.exports